import { render, staticRenderFns } from "./TheWellboreVisualization.vue?vue&type=template&id=60f17b56"
import script from "./TheWellboreVisualization.vue?vue&type=script&lang=ts"
export * from "./TheWellboreVisualization.vue?vue&type=script&lang=ts"
import style0 from "./TheWellboreVisualization.vue?vue&type=style&index=0&id=60f17b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports